import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ProgressSteps = ({ step }) => {
  const { t , i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  // Define step labels using translation keys.
  const steps = [
    t("ProgressSteps.propertyType"),
    t("ProgressSteps.address"),
    t("ProgressSteps.description"),
    t("ProgressSteps.rooms"),
    t("ProgressSteps.facilities"),
    t("ProgressSteps.images"),
  ];

  const currentLanguage  = i18n.language;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="progress-steps1">
      {isMobile ? (
        <ul>
          {steps.map((stepName, index) =>
            index === step ? (
              <div key={index} className="mobileViewStep">
                <h3>{t("ProgressSteps.stepLabel", { stepNumber: index + 1 })}</h3>
                <h4>{stepName}</h4>
              </div>
            ) : null
          )}
        </ul>
      ) : (
        // style={currentLanguage  === "he" ? {"right":"50%"} :{"left" :"50%"} }
        <ul className={currentLanguage === "he"  ? "progress-steps1-list-rtl progress-steps1-list" : "progress-steps1-list"}  >
          {steps.map((stepName, index) => (
            <li key={index} className={index <= step ? "active" : ""}>
              <div className="step-number">{index + 1}</div>
              <div className="step-name">{stepName}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

ProgressSteps.propTypes = {
  step: PropTypes.number.isRequired,
};

export default ProgressSteps;
